import { store } from "@betacrew/jars-flux";
import { componentKey, setLoadingState, setSelectedState,  setFormList, setSelectedForm,  setTaxYearList, setSelectedTaxYear, setPayersList, setSelectedPayer,  setStateList, setRejectedStatePayrollFormsGrid, setPaginationState, setFormListLoadingState, setPayerListLoadingState, setGridDataLoadingState, setDeleteStatePayrollRejectedFormModal, setClickedFormDetails, setUrlFormIdParam, setReloadReviewRejectedGridData, setUrlPayerIdParam, setSelectedRejectedStatePayrollForms  } from "./ReviewRejectedStatePayrollFormsSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import General from "../../../../../libs/utility/General";
import RightsManagementDataService from "../../../../../services/RightsManagementDataService";
import ResubmitDataService from "../../../../../services/ResubmitDataService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { REVIEW_REJECTED_LOADING_STATES } from "../constants";
import { COMMON_LOADING_STATES } from "../../../constants/constants";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";


export const { getStateList, getFormsList, getPayersBySelectedForm, getRejectedStatePayrollFormsGridData, resubmitStatePayrollRejectedForm, deleteStatePayrollRejectedForm, viewStatePayrollRejectedFormPDF } = {

    getStateList: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/GET_STATE_LIST",
            payload
        }
    },
    getFormsList: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/GET_FORMS",
            payload
        }
    },
    getPayersBySelectedForm: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/GET_PAYERS",
            payload
        }
    },
    getRejectedStatePayrollFormsGridData: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/GET_GRID_DATA",
            payload
        }
    },

    resubmitStatePayrollRejectedForm: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/RESUBMIT_FORM",
            payload
        }
    },

    deleteStatePayrollRejectedForm: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/DELETE_REJECTED_FORM",
            payload
        }
    },

    viewStatePayrollRejectedFormPDF: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS/VIEW_PDF",
            payload
        }
    }

}

function* getStateListAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.STATES_LIST_LOADING }));
        const { urlStateParam, urlTaxYearParam = null } = action.payload;
        const response = yield ResubmitDataService.getStatePayrollStateNames();
        const { Message, Status, Data } = response?.data;
        if (Status) {
            if (Data) {
                if (Array.isArray(Data?.StateNames)) {
                    const stateList = Data?.StateNames.map(state => ({ label: state?.StateName, value: state?.StateName }));
                    yield put(setStateList(stateList));
                    if (urlStateParam) {
                        const findSelectedStateRecord = stateList.find(state => state?.value === urlStateParam)
    
                        if (findSelectedStateRecord) {
                            yield put(setSelectedState(findSelectedStateRecord))
                        }
                    }
                } else {
                    yield put(addNotifications({ heading: "Error", message: "Statelist not found." }));
                }
                if (Data?.TaxYears) {
                    const taxYearsList = Data?.TaxYears.map(taxYear => ({ label: taxYear?.TaxYear, value: taxYear?.TaxYear }));
                    yield put(setTaxYearList(taxYearsList));
                    if (urlTaxYearParam) {
                        const findSelectedTaxYearRecord = taxYearsList.find(taxYear => taxYear?.value === urlTaxYearParam)
    
                        if (findSelectedTaxYearRecord) {
                            yield put(setSelectedTaxYear(findSelectedTaxYearRecord))
                        }
                    }
                } else {
                    yield put(addNotifications({ heading: "Error", message: "Tax year not found." }));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "State and tax year not found." }));
            }
        }
        else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.STATES_LIST_READY }))
    }
}

function* getFormsListAsync(action) {
    try {
        yield put(setFormListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_LOADING }));
        const { urlFormIdParam = null } = action.payload;
        const params = action.payload.stateName;
        const response = yield ResubmitDataService.getStatePayrollFormNames(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(Data){
                General.addOptionAndValueKeys(Data, "FormName1", "FormId")

                yield put(setFormList(Data));
                if (urlFormIdParam) {
                    const findSelectedFormRecord = Data.find(item => item?.value == urlFormIdParam)
                    if (findSelectedFormRecord) {
                        yield put(setSelectedForm(findSelectedFormRecord))
                    }
                    yield put(setUrlFormIdParam(null));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "forms not found." }));
            }
            
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setFormListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_READY }))
    }
}

function* getPayersBySelectedFormAsync(action) {
    try {
        yield put(setPayerListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_LOADING }));
        const { urlPayerIdParam = null } = action.payload;
        const response = yield RightsManagementDataService.reviewAndApprovePayers(action.payload);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(Data){
                const payersList = [...Data];
                General.addOptionAndValueKeys(payersList, "LastName", "PayerDetailId");
    
                yield put(setPayersList(payersList));
                if (urlPayerIdParam) {
                    const findSelectedPayerRecord = Data.find(item => item?.value == urlPayerIdParam)
                    if (findSelectedPayerRecord) {
                        yield put(setSelectedPayer(findSelectedPayerRecord))
                        yield put(setReloadReviewRejectedGridData(true));
                    }
                    yield put(setUrlPayerIdParam(null));
                }
            }
            else {
                yield put(addNotifications({ heading: "Error", message: "Payers not found." }));
            }

        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setPayerListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_READY }))
    }
}

function* getRejectedStatePayrollFormsGridDataAsync(action) {
    try {
        yield put(setGridDataLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING }));
        const { formId, payerId, taxYear, PageNumber, PageSize, FilterText, IdNumber, IsDesc } = action.payload

        const params = {
            formId,
            payerId,
            taxYear,
            PageNumber,
            PageSize,
            FilterText: "0",
            IdNumber: "0",
            IsDesc: false,
        }

        const response = yield RightsManagementDataService.reviewRejectedGridData(params);

        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {
            if(Data){
                yield put(setRejectedStatePayrollFormsGrid(Data));
                yield put(setPaginationState({ total: General.extractPaginationTotalFromResponse(response.data) }));
            }
            else {
                yield put(setRejectedStatePayrollFormsGrid([]));
                yield put(setSelectedRejectedStatePayrollForms([]));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setGridDataLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }));
        yield put(setReloadReviewRejectedGridData(false));
    }
}

function* resubmitStatePayrollRejectedFormAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_LOADING }));

        const { formIds, payerId, formName, payerName, taxyear, remarks, paginationState, formId } = action.payload;

        const params = {
            formIds,
            payerId,
            formName,
            payerName,
            taxyear,
            remarks
        };
        const response = yield RightsManagementDataService.resubmitRejectedForms(params);
        const { Status, Message} = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Form(s) Resubmitted Successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(getRejectedStatePayrollFormsGridData({ formId, payerId, taxYear: taxyear, ...paginationState }));
            yield put(setReloadReviewRejectedGridData(true));
        } else {
            yield put(addNotifications({ heading: "Failed to resubmit the form", message: Message }));
        }

    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_READY }))
    }
}

function* deleteStatePayrollRejectedFormAsync(action) {

    try {
        const { formSubmissionId, selectedForm, rejectedStatePayrollFormsGrid, selectedRejectedStatePayrollForms, payerId, taxyear, paginationState } = action.payload;

        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_LOADING }))

        let jsonData = rejectedStatePayrollFormsGrid.map(item => {
            let obj = {
                value: item.FormId
            };

            obj.key = selectedRejectedStatePayrollForms.some(selectedItem => selectedItem.FormId === item.FormId);

            return obj;
        });

        const params = {
            jsonPreferences: jsonData,
            formId: selectedForm?.value,
            formName: selectedForm?.FormName1,
        }

        const response = yield SubmitFormsDataService.deleteStatePayrollForms(params);
        const { Message, Status } = response?.data;

        if (Status) {
            yield put(setDeleteStatePayrollRejectedFormModal(false))
            yield put(getRejectedStatePayrollFormsGridData({ formId: selectedForm?.value, payerId, taxYear: taxyear, ...paginationState }));
            yield put(setClickedFormDetails({}))
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(setDeleteStatePayrollRejectedFormModal(false))
            yield put(addNotifications({ heading: "Failed to delete a form", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setDeleteStatePayrollRejectedFormModal(false))
        yield put(setClickedFormDetails({}))
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_READY }))
    }
}

function* viewStatePayrollRejectedFormPDFAsync(action) {
    try {
        const { formId, payerId, formTypeId, payerName } = action.payload
        yield put(setLoadingState({ state: `${REVIEW_REJECTED_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${formId}` }))

        const data = {
            formId,
            payerId: payerId,
            formTypeId: formTypeId,
            PayerName :payerName,
            isUnMask: false,
            employerId: 0
        }

        const response = yield SubmitFormsDataService.viewStatePayrollPDF(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(Data){
                General.openBase64FileInNewTab(Data.Base64, Data.Name)
            } else {
                yield put(addNotifications({ heading: "Error", message: "Failed to open the PDF" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.FETCHING_VIEW_PDF_LIST_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStateList().type, getStateListAsync),
        takeLatest(getFormsList().type, getFormsListAsync),
        takeLatest(getPayersBySelectedForm().type, getPayersBySelectedFormAsync),
        takeLatest(getRejectedStatePayrollFormsGridData().type, getRejectedStatePayrollFormsGridDataAsync),
        takeLatest(resubmitStatePayrollRejectedForm().type, resubmitStatePayrollRejectedFormAsync),
        takeLatest(deleteStatePayrollRejectedForm().type, deleteStatePayrollRejectedFormAsync),
        takeLatest(viewStatePayrollRejectedFormPDF().type, viewStatePayrollRejectedFormPDFAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);